<template>
  <b-col sm="12" :lg="size" :offset-lg="offset">
    <div class="animated fadeIn">
      <b-card class="backClass">

        <!-- Header -->
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">{{ title }}</h5>
          <div class="card-header-actions">
            <b-button
              v-if="chartType !== 'company'"
              variant="transparent p-1"
              @click="downloadExcel()"> 
              <i class="fa fa-file-excel-o" title="Download Excel" aria-hidden="true" style="color: rgb(32, 168, 216);"></i>
          </b-button>
            <b-button
              class="btn"
              variant="transparent p-1"
              attr="pdf"
              @click="downloadPDF()"
            >
            <i class="fa fa-file-pdf-o" style="color: rgb(32, 168, 216);" aria-hidden="true"></i>
            </b-button>
              <b-button
                @click="toggleFullScreen"
                variant="transparent p-1"
              >
                <i style="color: #20a8d8;" class="icon-frame"></i>
              </b-button>
              
            
          </div>
          <!-- Header END -->

        </div>

        <div class="chart-wrapper" >

          <!-- Loading -->
          <div style="height: 400px; padding-top: 150px" v-if="loadingData" class="loading" >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <!-- Loading END -->

          <!-- Chart -->
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
          <!-- Chart END -->

        </div>

        <!-- Footer -->
        <div slot="footer">
          <b-button
            :disabled="!showAll"
            class="btn-outline"
            variant="outline-primary"
            left
            @click="showAll = false, fetchData()"
          >Top 10
          </b-button>

          <b-button
            :disabled="showAll"
            class="btn-outline float-right"
            variant="outline-primary"
            right
            @click="showAll = true, fetchData()"
          >All Data
          </b-button>
          <!-- Footer END -->

        </div>
      </b-card>
    </div>
  </b-col>
</template>

<script>
    import {Chart} from "highcharts-vue";
    import Highcharts from "highcharts";
    import exporting from "highcharts/modules/exporting";
    import {chartOptionsFailureMixin} from "./addons/chartOptionsFailureMixin.js";
    import {chartFunctionsMixin} from "./addons/chartFunctionsMixin.js";

    exporting(Highcharts);

    export default {
        mixins: [chartOptionsFailureMixin, chartFunctionsMixin],
        components: {
            highcharts: Chart,
            Highcharts
        },
        props: ["size", "offset", "part", "type", "title"],
        data: function () {
            return {
                partNum: "",
                typeParam: "",
            };
        },
        methods: {
            downloadExcel() {
               this.loading2019 = true;
               let params = {};
               params = {
                 fns_part: encodeURIComponent(this.partNum),
                 xml: "true",
               };
             
             if (this.title === "Failure By Part") {
               this.excelDownload = "api/tec/tables/failureDataByPart.php";
             }

             if (this.title === "Failure By Designator") {
               this.excelDownload = "api/tec/tables/failureDataByDesignator.php";
             }

             if (this.title === "Failure By Complaint") {
               this.excelDownload = "api/tec/tables/failureDataByComplaint.php";
             }

             if (this.title === "Failure By Failure") {
               this.excelDownload = "api/tec/tables/failureDataByFailure.php";
             }
             
               this.$http
                 .get(this.excelDownload, {
                   params,
                   responseType: "blob"
                 })
                 .then(
                   res => {
                     const url = window.URL.createObjectURL(new Blob([res.data]));
                     const link = document.createElement("a");
                     link.href = url;
                     link.setAttribute("download", "TableReport.xlsx");
                     document.body.appendChild(link);
                     link.click();
                     this.loading2019 = false;
                   },
                   err => {
                     this.loading2019 = false;
                     console.log(err);
                   }
                 );
             },
            fetchData() {
                this.loadingData = true;
                let params = {};
                params = {
                    fns_part: encodeURIComponent(this.partNum)
                };
                this.$http
                    .get("api/tec/products/getFailureDataBy" + this.typeParam + ".php", {params}).then(
                    res => {
                        if (!this.showAll) {
                            this.chartOptions.series[0].data = res.data.slice(0, 10);
                        } else {
                            this.chartOptions.series[0].data = res.data;
                        }
                        this.chartOptions.title.text = "Total units: " + res.data.totals;

                        this.loadingData = false;
                        setTimeout(() => {
                            this.changeHeight();
                        });
                    },
                    err => {
                        this.loadingData = false;
                        console.log(err);
                    }
                );
            },
        },
        mounted() {
            this.typeParam = this.type;
            this.partNum = this.part;
            this.fetchData();
        }
    };
</script>

<style>
  /* IE fix */
  #card-chart-01,
  #card-chart-02 {
    width: 100% !important;
  }

  .highcharts-exporting-group {
    display: none !important;
  }
  /* Uniform icon button sizing and spacing */
.card-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.card-header-actions .btn {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 14px;
}
.card-header-actions .fa-file-excel-o {
  transform: none !important;
}
</style>
